export enum EventRegistrationViewStatus {
  Upcoming = 'Upcoming',
  Completed = 'Completed',
}
